import { useStore } from 'vuex'
import { onMounted, computed } from 'vue'
import GetLabel from 'foundation/js/getLabel'
import debounce from 'foundation/js/debounce'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: 'FilterOverlay',
    setup() {
        const store = useStore()
        const guids = computed(() => store.state.search.filter_overlay_scopes)
        const totalResultCount = computed(() => {
            return guids.value.reduce((sum, guid) => {
                const display = store.state.search.display_total[guid]
                return sum + (display ?? store.state.search.scoped_total[guid] ?? 0)
            }, 0)
        })

        const toggleAccordion = function (e) {
            const isExpanded = !!(
                e.currentTarget.getAttribute('aria-expanded') === 'true'
            )
            const accordionTarget = document.querySelector(
                '#' + e.currentTarget.getAttribute('aria-controls')
            )
            const chevronTarget = e.currentTarget.querySelector(
                '.kb-accordion__question__chevron'
            )

            chevronTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-accordion__question__chevron--open'
            )
            accordionTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-accordion__answer--open'
            )
            e.currentTarget.setAttribute(
                'aria-expanded',
                isExpanded ? 'false' : 'true'
            )
        }

        const filterResults = (facet) => {
            guids.value.forEach((guid) => {
                store.dispatch('search/performSearch', {
                    guid: guid,
                    query: inputText.value,
                    facet
                })
            })
        }

        const inputText = computed({
            get: () => store.state.search.queries[guids.value[0]] ?? '',
            set: (v) =>
                store.dispatch('search/setSearchQuery', {
                    guid: guids.value[0],
                    query: v
                })
        })
        const termInput = debounce(() => {
            guids.value.forEach((guid) => {
                store.dispatch('search/performSearch', {
                    guid: guid,
                    query: inputText.value
                })
            })
        }, 500)

        const closeOverlay = function (e) {
            store.dispatch('main/closePageOverlay')
            e.preventDefault()
        }

        const facetGroups = computed(
            () => store.getters['search/getFacets'](guids.value[0]) ?? []
        )

        let first, close, last

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                last.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            close = document.querySelector('.kb-page-overlay__close')
            first = document.querySelector('input[data-order="first"]')
            last = document.querySelector('input[data-order="last"]')
            last = last ? last : close
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )
        })

        return {
            facetGroups,
            filterResults,
            getLabel: (labelKey, params) =>
                GetLabel({ labelKey, params, labelCollection: 'filterOverlay' }),
            inputText,
            closeOverlay,
            termInput,
            toggleAccordion,
            totalResultCount,
            tabTrap
        }
    }
}
